import styled from 'styled-components';

export const PriceStyled = styled.div`
  position: relative;

  text-align: right;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;

  & span {
    margin-left: 5px;

    font-size: 16px;
    color: #e6a23c;
  }

  & em {
    font-style: normal;
    text-decoration: line-through;

    margin-left: 5px;

    color: #808080;
  }

  & p {
    padding: 0;
    margin: 0 0 5px 0;

    color: #e43a36;
  }
`;
